import { useCallback, useRef } from "react";
import { useSelector } from "react-redux";

const useViewPadding = (side) => {
  const animationFrame = useRef(-1);
  const view = useSelector((state) => state.mapViewReducer.view);

  const animatePadding = useCallback(
    (targetPadding) => {
      if (!view || !side) return;
      const currentPadding = view.padding[side] || 0;
      const step = (targetPadding - currentPadding) / 10; // Adjust the divisor for smoothness
      cancelAnimationFrame(animationFrame.current);

      function animate() {
        const sides = ["left", "right", "top", "bottom"];
        const padding = sides.reduce((acc, s) => {
          acc[s] = view.padding[s] || 0;
          return acc;
        }, {});

        const newPadding = view.padding[side] + step;

        if (
          (step > 0 && newPadding >= targetPadding) ||
          (step < 0 && newPadding <= targetPadding) ||
          (step === 0 && newPadding === targetPadding)
        ) {
          padding[side] = targetPadding;
          view.padding = padding;
          cancelAnimationFrame(animationFrame.current);
          return;
        }

        padding[side] = newPadding;
        // Update padding and request the next frame
        view.padding = padding;
        animationFrame.current = requestAnimationFrame(animate);
      }

      animate();
    },
    [view, side]
  );

  return {
    animatePadding,
  };
};

export default useViewPadding;
